import { Suspense } from "react";
import GlobalStyle from "manifest-components/src/Styles";
import { BrowserRouter as Router } from "react-router-dom";
// eslint-disable-next-line import/no-extraneous-dependencies
import { AuthProvider } from "react-oidc-context";
import * as Sentry from "@sentry/react";
import * as FS from "@fullstory/browser";
import { ExtraErrorData, CaptureConsole, HttpClient } from "@sentry/integrations";
import VersionProvider from "./context/Version/versionProvider";
import VersionNotifier from "./components/VersionNotifier";
import AppProvider from "./context/App/appProvider";
import DevelopmentEnvironmentProvider from "./context/DevelopmentEnvironment/developmentEnvironmentProvider";
import Routes from "./routes/AppRoutes";
import DevVersionIndicator from "./components/VersionIndicator";
import { clearCookiesOnStartup, migrateStorageToCookies } from "./utils/session";
import { envVariables, getEnvironmentName, isLocalEnvironment } from "./env";

if (envVariables.REACT_APP_HEAP_ID && window.heap && typeof window.heap.load === "function") {
  window.heap.load(envVariables.REACT_APP_HEAP_ID);
}
if (envVariables.REACT_APP_BEACON_ID) {
  (window.Beacon as any)("init", envVariables.REACT_APP_BEACON_ID);
}

// Perform any migration before starting the app
clearCookiesOnStartup();
migrateStorageToCookies();

// Sentry error logging integration (Do not enable for local dev, it logs too many errors)
if (!isLocalEnvironment()) {
  Sentry.init({
    environment: getEnvironmentName(),
    dsn: "https://addc1c73db7a43e59ba9bfba86ce8635@o384971.ingest.sentry.io/5217040",
    integrations: [
      new Sentry.BrowserTracing(),
      new Sentry.Replay({
        maskAllInputs: false,
        maskAllText: false,
        networkDetailAllowUrls: [
          `${envVariables.REACT_APP_API_BASE_URL}/config/employerCheck`,
          `${envVariables.REACT_APP_API_BASE_URL}/auth/signup`,
        ],
        networkRequestHeaders: ["X-Custom-Header"],
        networkResponseHeaders: ["X-Custom-Header"],
      }), // ADD sentry replay video to gain error replay
      new ExtraErrorData(),
      new CaptureConsole(),
      new HttpClient(),
    ],
    replaysSessionSampleRate: 1.0,
    tracesSampleRate: 1.0,
    ignoreErrors: ["No HENRY destination options is found", "API_ERROR"],
  });
  FS.init({
    orgId: "o-21WQ5P-na1",
  });
}

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_RqIJyZJGc",
  client_id: "5bpe0d4i4sjdghos0qv3ltctl0",
  redirect_uri: "https://dev.dev-manifest.com/redirect/auth",
  response_type: "code",
  scope: "email openid phone profile",
};

export default function App() {
  return (
    <Router>
      <AppProvider>
        <VersionProvider>
          <DevelopmentEnvironmentProvider>
            <GlobalStyle>
              <DevVersionIndicator />
              <VersionNotifier />
              <Suspense fallback={null}>
                <AuthProvider {...cognitoAuthConfig}>
                  <Routes />
                </AuthProvider>
              </Suspense>
            </GlobalStyle>
          </DevelopmentEnvironmentProvider>
        </VersionProvider>
      </AppProvider>
    </Router>
  );
}
